import router from '../router'
import indexedDB from '@/mixins/indexedDB'

const routerName = [
  'statement-info-inspection'
]

export default {
  install () {
    router.afterEach((to, from) => {
      if (!routerName.includes(to.name) && routerName.includes(from.name)) {
        indexedDB.methods.deleteDatabase()
      }
    })
  }
}